import './../App.css';
import '../css/pages/competences.css'
import { useEffect, useState } from 'react';
import bg1 from "../img/section-bg-1.jpg";
import { CompetenceItemsGrid, FooterComponent, FooterMainComponent, NosCompetenceContents } from '../components/MainComponents';
import { Link, NavLink } from 'react-router-dom';
import { Helmet } from 'react-helmet';


function Competence() {


    const [mobilenav, setMobilenav] = useState(false)

    const backgroundStyle4 = {
        backgroundImage: `url(${bg1})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
    }

    function topFunction() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }

    useEffect(() => {
        global.globalType = "all";
        document.documentElement.scrollTop = 0
    }, [])

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 992) {
                setMobilenav(false);
            }
        }
        handleResize();
        window.addEventListener("resize", handleResize);

    }, [window.innerWidth]);


    return (
        <div>
            <Helmet>
                <title>Décohome75 - Compétences</title>
                <meta name="description" content="Décohome75 est une entreprise de rénovation intégrale pour maison basée à Paris, France, spécialisée dans les rénovations de salle de bain, cuisine, murs et sols. Nous proposons des services de maçonnerie, plomberie, menuiserie, peinture et plâtrerie, électricité générale, parqueterie et carrelage." />
        <meta name="keywords" content="rénovation, maison, rénovation intégrale, rénovation complète, salle de bain, cuisine, murs et sols, maçonnerie, plomberie, menuiserie, peinture et plâtrerie, électricité générale, parqueterie, carrelage" />
        <meta name="robots" content="index, follow" />
      </Helmet>

            {/* navbar */}

            <div class="home-navbar">
                <div class="container mynavbar-container" >
                    <div class="">
                        <Link
                            to="/"
                            className="my-navbar-logo"
                            onClick={() => topFunction()}
                        ><img src="../assets/images/logo-dark.png" alt="" /></Link>
                    </div>
                    <div className='mynvabar-links'>
                        <NavLink
                            to="/entreprise"
                            id="entreprise"
                            className={({ isActive }) => isActive ? "my-navbar-link-active" : "my-navbar-link"}
                            onClick={() => topFunction()}
                        >
                            Qui sommes-nous
                        </NavLink>
                        <NavLink
                            to="/competence"
                            id="competence"
                            className={({ isActive }) => isActive ? "my-navbar-link-active" : "my-navbar-link"}
                            onClick={() => topFunction()}
                        >
                            Compétences
                        </NavLink>
                        <NavLink
                            to="/realisation"
                            id="realisation"
                            className={({ isActive }) => isActive ? "my-navbar-link-active" : "my-navbar-link"}
                            onClick={() => topFunction()}
                        >
                            Nos Réalisations
                        </NavLink>
                        <NavLink
                            to="/contact"
                            id="contact"
                            className={({ isActive }) => isActive ? "my-navbar-link-active" : "my-navbar-link"}
                            onClick={() => topFunction()}
                        >
                            Devis et Contact
                        </NavLink>

                    </div>
                    <div className='mynavbar-icon' onClick={() => { setMobilenav(!mobilenav) }}>
                        <i class="fa fa-bars" aria-hidden="true"></i>
                    </div>
                </div>
                <div className={`mynavbar-mobile-container ${mobilenav ? "mynavbar-mobile-container-visible" : ""}`}>
                    <div className='container mynavbar-links-mobile noPadding'>
                        <NavLink
                            to="/entreprise"
                            id="entreprise"
                            className={({ isActive }) => isActive ? "my-navbar-link-active" : "my-navbar-link"}
                            onClick={() => topFunction()}
                        >
                            Qui sommes-nous
                        </NavLink>
                        <NavLink
                            to="/competence"
                            id="competence"
                            className={({ isActive }) => isActive ? "my-navbar-link-active" : "my-navbar-link"}
                            onClick={() => topFunction()}
                        >
                            Compétences
                        </NavLink>
                        <NavLink
                            to="/realisation"
                            id="realisation"
                            className={({ isActive }) => isActive ? "my-navbar-link-active" : "my-navbar-link"}
                            onClick={() => topFunction()}
                        >
                            Nos Réalisations
                        </NavLink>
                        <NavLink
                            to="/contact"
                            id="contact"
                            className={({ isActive }) => isActive ? "my-navbar-link-active" : "my-navbar-link"}
                            onClick={() => topFunction()}
                        >
                            Devis et Contact
                        </NavLink>
                    </div>
                </div>
            </div>


            {/* competence grid */}

            <section id="services">
                <CompetenceItemsGrid parent="competence" />
            </section>
            
                    {/* Nos competence */}

                    <section class="home-noscompetence-area" >
                        <div class="noscompetenceHeader">
                            <div class="noscompetenceTitle">
                                Nos Compétences<span>.</span>
                            </div>
                            <h2 class="noscompetenceDesc">Nous fournissons une liste complète des meilleurs services numériques</h2>
                            <hr class="home-hr" ></hr>
                        </div>
                        <div class="noscompetenceBody container noPadding">
                            <NosCompetenceContents />
                        </div>
                    </section>


            <FooterMainComponent />

            <FooterComponent />

        </div>
    );
}


export default Competence;
